import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";
import OrderTracking from "./pages/OrderTracking";
import TileLayers from "./pages/TileLayers";
import Refer from "./pages/Refer";
import Reviews from "./pages/Reviews";
import Returns from "./pages/Returns";
import Projects from "./pages/Projects";
import Credits from "./pages/Credits";
import YetToReceive from "./pages/YetToReceive";
import BrowseBySize from "./pages/BrowseBySize";
import Admin from "./pages/Admin";
import BuyerLogin from "./pages/BuyerLogin";
import BuyerSignup from "./pages/BuyerSignup";
import ForgotPassword from "./pages/ForgotPassword";
import EmployeeLogin from "./pages/EmployeeLogin";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import ChatAssistant from "./components/ChatAssistant";

function RequireBuyer({ children }) {
  const { customer, loading } = useApp();
  const loc = useLocation();
  if (loading) return <div className="p-20 text-center text-[#8A8A8A]" data-testid="auth-loading">Loading...</div>;
  if (!customer) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function AdminGate({ children }) {
  // A buyer who is signed in must never see the admin panel.
  const { customer, loading } = useApp();
  if (loading) return <div className="p-20 text-center text-[#8A8A8A]" data-testid="auth-loading">Loading...</div>;
  if (customer) return <Navigate to="/catalog" replace />;
  return children;
}

function Shell() {
  return (
    <div className="App bg-grain">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<BuyerLogin />} />
        <Route path="/signup" element={<BuyerSignup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/catalog" element={<RequireBuyer><Catalog /></RequireBuyer>} />
        <Route path="/product/:id" element={<RequireBuyer><ProductDetail /></RequireBuyer>} />
        <Route path="/cart" element={<RequireBuyer><Cart /></RequireBuyer>} />
        <Route path="/checkout" element={<RequireBuyer><Checkout /></RequireBuyer>} />
        <Route path="/orders" element={<RequireBuyer><Orders /></RequireBuyer>} />
        <Route path="/orders/:id" element={<RequireBuyer><OrderTracking /></RequireBuyer>} />
        <Route path="/refer" element={<RequireBuyer><Refer /></RequireBuyer>} />
        <Route path="/tile-layers" element={<RequireBuyer><TileLayers /></RequireBuyer>} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/returns" element={<RequireBuyer><Returns /></RequireBuyer>} />
        <Route path="/projects" element={<RequireBuyer><Projects /></RequireBuyer>} />
        <Route path="/credits" element={<RequireBuyer><Credits /></RequireBuyer>} />
        <Route path="/yet-to-receive" element={<RequireBuyer><YetToReceive /></RequireBuyer>} />
        <Route path="/browse-by-size" element={<RequireBuyer><BrowseBySize /></RequireBuyer>} />
        <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
        <Route path="/employee/login" element={<EmployeeLogin />} />
        <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
      </Routes>
      <ChatAssistant />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AppProvider>
  );
}
